import { createReducer, on } from '@ngrx/store'
import { trackTemplateUsage } from '../actions/template-usage.actions'

export type TemplateUsageState = Record<string, Record<string, number>>

export const initialState: TemplateUsageState = {}

export const reducer = createReducer(
  initialState,
  on(trackTemplateUsage, (state, { userId, templateId }) => ({
    ...state,
    [userId]: {
      ...(state[userId] ?? {}),
      [templateId]: ((state[userId] ?? {})[templateId] ?? 0) + 1,
    },
  }))
)
